module.exports = __webpack_public_path__ + "static/media/call.ff01f2cc.png";